import { render, staticRenderFns } from "./PageManageBase.vue?vue&type=template&id=efb714e8&scoped=true&"
import script from "./PageManageBase.vue?vue&type=script&lang=js&"
export * from "./PageManageBase.vue?vue&type=script&lang=js&"
import style0 from "./PageManageBase.vue?vue&type=style&index=0&id=efb714e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb714e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs,VTabsSlider})
